var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-toolbar",
        { attrs: { color: "primary", dark: "", dense: "", elevation: "0" } },
        [
          _c("span", [_vm._v("Stock Category")]),
          _c("v-spacer"),
          _c("v-icon", [_vm._v("mdi-account")])
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          dense: "",
          items: _vm.stockCatList,
          headers: _vm.headers,
          loading: this.stockCatGetting,
          search: _vm.search
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function() {
              return [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "3" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            label: "search",
                            "append-icon": "mdi-magnify"
                          },
                          model: {
                            value: _vm.search,
                            callback: function($$v) {
                              _vm.search = $$v
                            },
                            expression: "search"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "item",
            fn: function({ item }) {
              return [
                _c("tr", [
                  _c("td", [_vm._v(_vm._s(item.id))]),
                  _c("td", [_vm._v(_vm._s(item.name))]),
                  _c("td", [_vm._v(_vm._s(item.revenue_source.code))]),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        item.updated_at.dateFormat({
                          hour: "2-digit",
                          minute: "2-digit"
                        })
                      )
                    )
                  ]),
                  _c(
                    "td",
                    [
                      _c(
                        "base-tooltip",
                        {
                          attrs: {
                            tooltip: "Units",
                            text: "",
                            bottom: "",
                            color: "blue-grey darken-3"
                          },
                          on: {
                            click: function($event) {
                              return _vm.$emit("update:unit", item)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-weight")])],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            text: "",
                            color: "yellow darken-2",
                            small: "",
                            dense: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.$emit("input", item)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-pencil")])],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }